module.exports = __webpack_public_path__ + "img/UTPIUT-3.feeafe66.jpg";